import { render } from "./signature.vue?vue&type=template&id=e475e4b6&scoped=true&ts=true"
import script from "./signature.vue?vue&type=script&lang=ts"
export * from "./signature.vue?vue&type=script&lang=ts"

import "./signature.vue?vue&type=style&index=0&id=e475e4b6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e475e4b6"]])

export default __exports__